import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import StatsSection from './components/StatsSection';
import CategoryGrid from './components/CategoryGrid';
import AuthorityContent from './components/AuthorityContent';
import TrendingFinds from './components/TrendingFinds';
import ArticleEntry from './components/ArticleEntry';
import Testimonials from './components/Testimonials';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'CSSBuy Spreadsheet Directory',
  url: 'https://cssspreadsheet.skin/',
  description:
    'The largest CSSBuy Spreadsheet directory for 2026 — verified fashion finds, sneakers, luxury items, and trusted sellers updated daily.',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://cssspreadsheet.skin/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'CSSSpreadsheet',
  url: 'https://cssspreadsheet.skin/',
  logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/d367cf6745ee47f3fc82c76d3a54c50c.png',
  description:
    'The largest CSSBuy Spreadsheet directory for 2026 — verified fashion finds, sneakers, luxury items, and trusted sellers updated daily.',
  sameAs: [
    'https://kaspreadsheet.com',
  ],
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>

      <Navbar />

      <main>
        <Hero />

        <StatsSection />

        <CategoryGrid />

        <AuthorityContent />

        <TrendingFinds />

        <ArticleEntry />

        <Testimonials />

        <FAQSection />

        <CTASection />
      </main>

      <Footer />
    </>
  );
}